/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  addSubAdmin,
  deleteSubAdmin,
  loadSubAdmin,
  updateSubMentor,
  rensedInvitationForSubAdmin,
  searchSubAdminFromDB,
} from "./SubAdminApi";

const initialState: any = {
  loading: false,
  resend_invitaiton_loading: false,
  adderLoading: false,
  deleteLoading: false,
  updateLoading: false,
  editUser: false,
  req_success: false,
  resend_invitation_success: false,
  delete_success: false,
  edit_success: false,
  add_success: false,
  single_user_info: {},
  current_page: 1,
  pagination_data:null,
  all_users: [],
  temp_users: [],
  users: [],
};

const subAdminSlice = createSlice({
  name: "subAdmin",
  initialState,
  reducers: {
    editSubAdminInfo: (state: any, { payload }: PayloadAction<any>) => {
      state.editUser = true;
      state.single_user_info = payload;
    },
    closeSubAdminEditModal: (state: any, { payload }: PayloadAction<any>) => {
      state.editUser = false;
      state.edit_success = false;
    },
    refreshSubAdmin: (state: any) => {
      state.users = state.all_users.slice(0, 10);
    },
    subAdminPaginate: (state: any, { payload }: PayloadAction<any>) => {
   
    },
    setSubadminCurrentPage: (state, { payload }: PayloadAction<any>) => {
      state.current_page = payload;
    },

    searchSubAdmin: (state: any, { payload }: PayloadAction<any>) => {
      if (payload?.length > 1) {
        state.temp_users = state.all_users.filter(
          (user: any) =>
            user.name.toLowerCase().includes(payload.toLowerCase()) ||
            user.email.toLowerCase().includes(payload.toLowerCase())
        );
        state.users = state.temp_users;
      } else {
        state.users = state.all_users;
      }
    },
  },
  extraReducers: (builder) => {
    // LOAD USERS
    builder.addCase(loadSubAdmin.pending, (state) => {
      state.loading = true;
      state.req_success = false;
    });
    builder.addCase(
      loadSubAdmin.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading = false;
        state.req_success = true;
        state.all_users = payload?.data?.data;
        state.users = state.all_users;
        state.pagination_data = payload?.data?.pagination
      }
    );
    builder.addCase(loadSubAdmin.rejected, (state) => {
      state.loading = false;
    });
            // GET Sub admin BY Search
        builder.addCase(searchSubAdminFromDB.pending, (state) => {
          state.loading = true;
          state.req_success = false;
        });
        builder.addCase(
          searchSubAdminFromDB.fulfilled,
          (state, { payload }: PayloadAction<any>) => {
            state.loading = false;
            state.req_success = true;
            state.all_users = payload?.data?.data;
            state.users = state.all_users;
            state.pagination_data = payload?.data?.pagination
          }
        );
        builder.addCase(searchSubAdminFromDB.rejected, (state) => {
          state.loading = false;
        });

    // ADD USERS
    builder.addCase(addSubAdmin.pending, (state) => {
      state.adderLoading = true;
      state.add_success = false;
    });
    builder.addCase(
      addSubAdmin.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.adderLoading = false;
        state.add_success = true;
        // if (payload.data) {
        //   state.all_users = [payload?.data, ...state.all_users];

        //   if (state.current_page === 0) {
        //     state.users = state.all_users.slice(0, 10);
        //   } else {
        //     state.users = state.all_users.slice(
        //       state.current_page * 10,
        //       state.current_page * 10 + 10
        //     );
        //   }
        // }
      }
    );
    builder.addCase(addSubAdmin.rejected, (state) => {
      state.adderLoading = false;
      state.add_success = false;
    });

    // RESEND INVITATION
    builder.addCase(rensedInvitationForSubAdmin.pending, (state) => {
      state.resend_invitaiton_loading = true;
      state.resend_invitation_success = false;
      state.edit_success = false;
    });
    builder.addCase(
      rensedInvitationForSubAdmin.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.resend_invitaiton_loading = false;
        state.resend_invitation_success = true;
        state.edit_success = true;
        state.editUser = false;
      }
    );
    builder.addCase(rensedInvitationForSubAdmin.rejected, (state) => {
      state.resend_invitaiton_loading = false;
    });

    // update USERS
    builder.addCase(updateSubMentor.pending, (state) => {
      state.adderLoading = true;
      state.edit_success = false;
    });
    builder.addCase(
      updateSubMentor.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.adderLoading = false;
        state.edit_success = true;
        // state.users = state.users.map((user: any) => {
        //   if (user.id === payload?.data.id) {
        //     return payload?.data;
        //   }
        //   return user;
        // });

        // state.all_users = state.all_users.map((user: any) => {
        //   if (user.id === payload?.data.id) {
        //     return payload?.data;
        //   }
        //   return user;
        // });
      }
    );
    builder.addCase(updateSubMentor.rejected, (state) => {
      state.adderLoading = false;
      state.edit_success = false;
    });

    // DELETE USERS
    builder.addCase(deleteSubAdmin.pending, (state) => {
      state.deleteLoading = true;
      state.delete_success = false;
    });
    builder.addCase(
      deleteSubAdmin.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.deleteLoading = false;
        state.delete_success = true;
        // state.all_users = state.all_users.filter(
        //   (user: any) => user.id !== payload?.id
        // );
        // if (state.current_page === 0) {
        //   state.users = state.all_users.slice(0, 10);
        // } else {
        //   state.users = state.all_users.slice(
        //     state.current_page * 10,
        //     state.current_page * 10 + 10
        //   );
        // }

        // state.users = state.users.filter(
        //   (user: any) => user.id !== payload?.id,
        // );
      }
    );
    builder.addCase(deleteSubAdmin.rejected, (state) => {
      state.delete_success = false;
      state.deleteLoading = false;
    });
  },
});

// export const { setRecentSignupEmail, invokeLogout } = subAdminSlice.actions;
export const {
  editSubAdminInfo,
  subAdminPaginate,
  searchSubAdmin,
  closeSubAdminEditModal,
  refreshSubAdmin,
  setSubadminCurrentPage
} = subAdminSlice.actions;
export default subAdminSlice.reducer;
